import { render, staticRenderFns } from "./UserAccessesButtonLink.vue?vue&type=template&id=81127812&scoped=true&"
import script from "./UserAccessesButtonLink.vue?vue&type=script&lang=js&"
export * from "./UserAccessesButtonLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81127812",
  null
  
)

export default component.exports